import React, { useEffect, useRef } from 'react';
import '../../styles/CustomerSiteStyles/ReviewsGroup.css';

function ReviewsGroup() {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;

        const iframe = document.createElement('iframe');
        iframe.className = 'lc_reviews_widget';
        iframe.title = 'Customer Reviews';
        iframe.src = 'https://reputationhub.site/reputation/widgets/review_widget/nIW7fd2txQKnklN52nDL?widgetId=6a7215a1796dbac1b28f6d45';
        iframe.frameBorder = '0';
        iframe.scrolling = 'no';
        iframe.style.minWidth = '100%';
        iframe.style.width = '100%';
        container.appendChild(iframe);

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://reputationhub.site/reputation/assets/review-widget.js';
        document.body.appendChild(script);

        return () => {
            container.removeChild(iframe);
            document.body.removeChild(script);
        };
    }, []);

    return <div className="reviews-group-container" ref={containerRef} />;
}

export default ReviewsGroup;
